import { Injectable } from '@angular/core';
import { Service } from 'ngx-jsonapi';
import { Invoice } from '@app/core/resources/invoice';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class InvoicesService extends Service<Invoice> {
    public resource: typeof Invoice = Invoice;
    public type: string = 'invoices';

    public constructor() {
        super();
        this.register();
    }

    public includeUserData(id: string, beforepath: string): Observable<Invoice> {
        return this.get(id, { include: ['user_fiscal_data'], beforepath: beforepath });
    }
}
